import { Schema } from 'prosemirror-model';
import OrderedMap from 'orderedmap';
import get from 'lodash/get';
import partialRight from 'lodash/partialRight';

function filterObject(obj, keys, mapping) {
   const updated = keys.map(k => get(mapping, k, k));
   const ret = OrderedMap.from();

   // OrderedMap retains insertion order on the keys in it. Inserting a key
   // twice overwrites it and puts it in the new location (e.g., inserting `a, b,
   // a` results in `b, a`. By doing our insertions from the right and inserting
   // at start, we keep the first occurrence of each key, rather than
   // the last. Thus, our previous example would result in `a, b`.
   return updated
      .filter(key => obj.get(key))
      .reduceRight((map, k) => map.addToStart(k, obj.get(k)), ret);
}

function filterSchema(schema, available, mapping) {
   // Add nodes that we need to have to make ProseMirror work. `paragraph` is in
   // here to work around ProseMirror's requirement that there is a node with an
   // `inline` content before any node with both the content and the group set
   // to block. If we don't do this, the editor crashes on creation. Since our
   // filtering method keeps the nodes in the order they appear in
   // `availableNodes`, this makes sure `paragraph` is before other nodes that
   // could cause trouble.
   const availableNodes = ['doc', 'paragraph', 'text'].concat(available);
   const filterByAvailableNodes = partialRight(filterObject, availableNodes, mapping);
   return new Schema({
      nodes: filterByAvailableNodes(schema.spec.nodes),
      marks: filterByAvailableNodes(schema.spec.marks),
   });
}

export default filterSchema;
